import React from "react";
import "./loading.css";

const Loading = () => {
  return (
    <div class="ring">
      VESTIDOs
      <span></span>
    </div>
  );
};

export default Loading;
